import { render, staticRenderFns } from "./NPWPUpload.vue?vue&type=template&id=6811932f&scoped=true&"
import script from "./NPWPUpload.vue?vue&type=script&lang=js&"
export * from "./NPWPUpload.vue?vue&type=script&lang=js&"
import style0 from "./NPWPUpload.vue?vue&type=style&index=0&id=6811932f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6811932f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
